var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 230,
    viewBox: "0 0 300 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H294C297.314 0 300 3.53021 300 8V222C300 226.47 297.314 230 294 230H6C2.68629 230 0 226.47 0 222V8C0 3.53021 2.68629 0 6 0ZM299 221V8C298.997 3.93884 296.76 1.00434 294 1H6C3.23995 1.00434 1.00331 3.93884 1 8V221C1.00331 225.061 3.23995 228.996 6 229H294C296.76 228.996 298.997 225.061 299 221Z",
    fill: "#D6DCDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 5.013V13H0V5.013C0 2.819 2.791 0 5 0H294C296.209 0 299 2.819 299 5.013ZM292 9C293.105 9 294 8.08175 294 6.94903C293.971 5.84522 293.076 4.97364 292 5.00061C290.924 4.97364 290.029 5.84522 290 6.94903C290 8.08175 290.895 9 292 9ZM288 6.94903C288 8.08175 287.105 9 286 9C284.895 9 284 8.08175 284 6.94903C284.029 5.84522 284.924 4.97364 286 5.00061C287.076 4.97364 287.971 5.84522 288 6.94903ZM280 9C281.105 9 282 8.08175 282 6.94903C281.971 5.84522 281.076 4.97364 280 5.00061C278.924 4.97364 278.029 5.84522 278 6.94903C278 8.08175 278.895 9 280 9Z",
    fill: "#D6DCDD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 88,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 108,
    width: 104,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 120,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#E6EAEB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 63.5,
    width: 109,
    height: 109,
    stroke: "#E6EAEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254 98.6667C254 103.333 249.333 108 244.667 108C238.667 108 234 103.333 234 98.6667C234 92.6667 238.667 88 244.667 88C249.333 88 254 92.6667 254 98.6667ZM229 140L241 121.333L261 148H181L207.667 108L229 140Z",
    fill: "#E6EAEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty_table.3754e0ef502962ce2f1c32a28d71c9ab.svg";
export { ForwardRef as ReactComponent };